export { default } from './OriginatorCompCard';
